import React, { useState } from "react";
import SectionContainer from "../../../Homepage/SectionContainer";
import { Col, Container, Row } from "reactstrap";

import ieltsImage from "../../../assets/kangaroo/ieltsprep.png";
import pearsonImage from "../../../assets/kangaroo/pearson.png";
import toeflImage from "../../../assets/kangaroo/toefl.png";
import duolingoImage from "../../../assets/kangaroo/duolingo.png";
import greImage from "../../../assets/kangaroo/gre.png";
import satImage from "../../../assets/kangaroo/sat.png";
import gmatImage from "../../../assets/kangaroo/gmat.png";
import Button from "../../../component/button/Button";
import Page8 from "../../../Homepage/Map";
import SmallPage from "../../../Homepage/SmallPage";
import { useNavigate } from "react-router-dom";
import FormGoldBg from "../../../component/FormCloseGold/FormGoldBg";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import InlineForm from "../../../component/InlineForm/InlineForm";
import DynamicInlineForm from "../../../component/DynamicInline/DynamicInlineForm";

const TestPreparation = () => {
  const navigate = useNavigate();
  const [thankYouModal, setThankYouModal] = useState(false);

  const toggleThankYou = () => setThankYouModal(!thankYouModal);

  const testPreps = [
    { id: 1, img: ieltsImage, route: "/testprep/ielts" },
    { id: 2, img: pearsonImage, route: "/testprep/ielts" },
    { id: 3, img: toeflImage, route: "/testprep/ielts" },
    { id: 4, img: duolingoImage, route: "/testprep/ielts" },
    { id: 5, img: satImage, route: "/testprep/ielts" },
    { id: 6, img: greImage, route: "/testprep/ielts" },
    { id: 7, img: gmatImage, route: "/testprep/ielts" },
  ];
  return (
    <>
      <SectionContainer>
        <Container fluid>
          <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "TEST PREPARATION" },
            ]}
            instituition={true}
          />

          <Row className="mb-5">
            <Col>
              <h1 className="font-level-5">
                YOUR PATH TO <br /> WORLD CLASS TEST <br /> PREPARATION STARTS
                HERE
              </h1>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col>
              <Row className="g-3 ">
                {testPreps.map((item) => (
                  <Col lg={4} sm={12} key={item.id}>
                    <div
                      className="rounded-5 img-size-testPrep overflow-hidden"
                      style={{
                        cursor: "pointer",
                        boxShadow: "0 0 0 1px #687c8694",
                      }}
                      onClick={() => navigate(item.route)}
                    >
                      <img
                        src={item.img}
                        alt={`Test Prep ${item.id}`}
                        className="rounded img-fluid w-100 h-100 object-fit-cover"
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </SectionContainer>
      <Row style={{ marginTop: "12.4rem", marginBottom: "12.4rem" }}>
        <Col>
          {" "}
          <SectionContainer mainId="ielts-prep-subpage">
            <Row style={{ marginTop: "6rem" }}>
              <Col>
                <h1 className="font-heading">
                  Start Smart With Expert Test Preparation Classes & Guidance
                </h1>
                <p className="font-desc mt-3 mb-4">
                  Fill in the details below, and our test preparation advisors
                  will guide you toward the right preparation plan and class for
                  your goals.
                </p>
              </Col>
            </Row>

            <DynamicInlineForm
              fullName={true}
              emailAddress={true}
              phoneNumber={true}
              testPrepClasses={true}
              callBackTime={true}
              nearestOffice={true}
              message={true}
            />
            <div className="d-flex justify-content-end">
              <div
                style={{
                  width: "max-content",
                  marginTop: "4rem",
                  marginBottom: "8rem",
                }}
                onClick={toggleThankYou}
              >
                <Button
                  label="BOOK YOUR CLASS"
                  margin="20px 0"
                  width="350.4053px"
                  height="60px"
                  fontSize="22px"
                  fontWeight="500"
                  textColor="#890295"
                  fontFamily="Proxima Nova Bold"
                />
              </div>
            </div>
          </SectionContainer>
          <FormGoldBg
            modal={thankYouModal}
            toggle={toggleThankYou}
            heading="YOU'RE ONE STEP CLOSER TO STARTING SMART"
            description="Our team will connect with you shortly"
          />
        </Col>
      </Row>

      <SectionContainer mainId="test-prep-subpage-margin">
        <div className="page-content">
          <Page8 />
        </div>
        <hr className="line-style-testprep" />
      </SectionContainer>

      <SectionContainer>
        <SmallPage countryPage={true} />
      </SectionContainer>
    </>
  );
};

export default TestPreparation;
